var map = {
	"./$pac.png": 349,
	"./0xbtc.png": 350,
	"./2give.png": 351,
	"./aave.png": 352,
	"./abt.png": 353,
	"./act.png": 354,
	"./actn.png": 355,
	"./ada.png": 356,
	"./add.png": 357,
	"./adx.png": 358,
	"./ae.png": 359,
	"./aeon.png": 360,
	"./aeur.png": 361,
	"./agi.png": 362,
	"./agrs.png": 363,
	"./aion.png": 364,
	"./algo.png": 365,
	"./amb.png": 366,
	"./amp.png": 367,
	"./ampl.png": 368,
	"./ankr.png": 369,
	"./ant.png": 370,
	"./apex.png": 371,
	"./appc.png": 372,
	"./ardr.png": 373,
	"./arg.png": 374,
	"./ark.png": 375,
	"./arn.png": 376,
	"./arnx.png": 377,
	"./ary.png": 378,
	"./ast.png": 379,
	"./atm.png": 380,
	"./atom.png": 381,
	"./audr.png": 382,
	"./auto.png": 383,
	"./aywa.png": 384,
	"./bab.png": 385,
	"./bal.png": 386,
	"./band.png": 387,
	"./bat.png": 388,
	"./bay.png": 389,
	"./bcbc.png": 390,
	"./bcc.png": 391,
	"./bcd.png": 392,
	"./bch.png": 393,
	"./bcio.png": 394,
	"./bcn.png": 395,
	"./bco.png": 396,
	"./bcpt.png": 397,
	"./bdl.png": 398,
	"./beam.png": 399,
	"./bela.png": 400,
	"./bix.png": 401,
	"./blcn.png": 402,
	"./blk.png": 403,
	"./block.png": 404,
	"./blz.png": 405,
	"./bnb.png": 406,
	"./bnt.png": 407,
	"./bnty.png": 408,
	"./booty.png": 409,
	"./bos.png": 410,
	"./bpt.png": 411,
	"./bq.png": 412,
	"./brd.png": 413,
	"./bsd.png": 414,
	"./bsv.png": 415,
	"./btc.png": 416,
	"./btcd.png": 417,
	"./btch.png": 418,
	"./btcp.png": 419,
	"./btcz.png": 420,
	"./btdx.png": 421,
	"./btg.png": 422,
	"./btm.png": 423,
	"./bts.png": 424,
	"./btt.png": 425,
	"./btx.png": 426,
	"./burst.png": 427,
	"./bze.png": 428,
	"./call.png": 429,
	"./cc.png": 430,
	"./cdn.png": 431,
	"./cdt.png": 432,
	"./cenz.png": 433,
	"./chain.png": 434,
	"./chat.png": 435,
	"./chips.png": 436,
	"./chsb.png": 437,
	"./cix.png": 438,
	"./clam.png": 439,
	"./cloak.png": 440,
	"./cmm.png": 441,
	"./cmt.png": 442,
	"./cnd.png": 443,
	"./cnx.png": 444,
	"./cny.png": 445,
	"./cob.png": 446,
	"./colx.png": 447,
	"./comp.png": 448,
	"./coqui.png": 449,
	"./cred.png": 450,
	"./crpt.png": 451,
	"./crv.png": 452,
	"./crw.png": 453,
	"./cs.png": 454,
	"./ctr.png": 455,
	"./ctxc.png": 456,
	"./cvc.png": 457,
	"./d.png": 458,
	"./dai.png": 459,
	"./dash.png": 460,
	"./dat.png": 461,
	"./data.png": 462,
	"./dbc.png": 463,
	"./dcn.png": 464,
	"./dcr.png": 465,
	"./deez.png": 466,
	"./dent.png": 467,
	"./dew.png": 468,
	"./dgb.png": 469,
	"./dgd.png": 470,
	"./dlt.png": 471,
	"./dnt.png": 472,
	"./dock.png": 473,
	"./doge.png": 474,
	"./dot.png": 475,
	"./drgn.png": 476,
	"./drop.png": 477,
	"./dta.png": 478,
	"./dth.png": 479,
	"./dtr.png": 480,
	"./ebst.png": 481,
	"./eca.png": 482,
	"./edg.png": 483,
	"./edo.png": 484,
	"./edoge.png": 485,
	"./ela.png": 486,
	"./elec.png": 487,
	"./elf.png": 488,
	"./elix.png": 489,
	"./ella.png": 490,
	"./emb.png": 491,
	"./emc.png": 492,
	"./emc2.png": 493,
	"./eng.png": 494,
	"./enj.png": 495,
	"./entrp.png": 496,
	"./eon.png": 497,
	"./eop.png": 498,
	"./eos.png": 499,
	"./eqli.png": 500,
	"./equa.png": 501,
	"./etc.png": 502,
	"./eth.png": 503,
	"./ethos.png": 504,
	"./etn.png": 505,
	"./etp.png": 506,
	"./eur.png": 507,
	"./evx.png": 508,
	"./exmo.png": 509,
	"./exp.png": 510,
	"./fair.png": 511,
	"./fct.png": 512,
	"./fil.png": 513,
	"./fjc.png": 514,
	"./fldc.png": 515,
	"./flo.png": 516,
	"./flux.png": 517,
	"./fsn.png": 518,
	"./ftc.png": 519,
	"./fuel.png": 520,
	"./fun.png": 521,
	"./game.png": 522,
	"./gas.png": 523,
	"./gbp.png": 524,
	"./gbx.png": 525,
	"./gbyte.png": 526,
	"./generic.png": 527,
	"./gin.png": 528,
	"./glxt.png": 529,
	"./gmr.png": 530,
	"./gno.png": 531,
	"./gnt.png": 532,
	"./gold.png": 533,
	"./grc.png": 534,
	"./grin.png": 535,
	"./grs.png": 536,
	"./grt.png": 537,
	"./gsc.png": 538,
	"./gto.png": 539,
	"./gup.png": 540,
	"./gusd.png": 541,
	"./gvt.png": 542,
	"./gxs.png": 543,
	"./gzr.png": 544,
	"./hight.png": 545,
	"./hns.png": 546,
	"./hodl.png": 547,
	"./hot.png": 548,
	"./hpb.png": 549,
	"./hsr.png": 550,
	"./ht.png": 551,
	"./html.png": 552,
	"./huc.png": 553,
	"./husd.png": 554,
	"./hush.png": 555,
	"./icn.png": 556,
	"./icp.png": 557,
	"./icx.png": 558,
	"./ignis.png": 559,
	"./ilk.png": 560,
	"./ink.png": 561,
	"./ins.png": 562,
	"./ion.png": 563,
	"./iop.png": 564,
	"./iost.png": 565,
	"./iotx.png": 566,
	"./iq.png": 567,
	"./itc.png": 568,
	"./jnt.png": 569,
	"./jpy.png": 570,
	"./kcs.png": 571,
	"./kin.png": 572,
	"./klown.png": 573,
	"./kmd.png": 574,
	"./knc.png": 575,
	"./krb.png": 576,
	"./ksm.png": 577,
	"./lbc.png": 578,
	"./lend.png": 579,
	"./leo.png": 580,
	"./link.png": 581,
	"./lkk.png": 582,
	"./loom.png": 583,
	"./lpt.png": 584,
	"./lrc.png": 585,
	"./lsk.png": 586,
	"./ltc.png": 587,
	"./lun.png": 588,
	"./maid.png": 589,
	"./mana.png": 590,
	"./matic.png": 591,
	"./max.png": 592,
	"./mcap.png": 593,
	"./mco.png": 594,
	"./mda.png": 595,
	"./mds.png": 596,
	"./med.png": 597,
	"./meetone.png": 598,
	"./mft.png": 599,
	"./miota.png": 600,
	"./mith.png": 601,
	"./mkr.png": 602,
	"./mln.png": 603,
	"./mnx.png": 604,
	"./mnz.png": 605,
	"./moac.png": 606,
	"./mod.png": 607,
	"./mona.png": 608,
	"./msr.png": 609,
	"./mth.png": 610,
	"./mtl.png": 611,
	"./music.png": 612,
	"./mzc.png": 613,
	"./nano.png": 614,
	"./nas.png": 615,
	"./nav.png": 616,
	"./ncash.png": 617,
	"./ndz.png": 618,
	"./nebl.png": 619,
	"./neo.png": 620,
	"./neos.png": 621,
	"./neu.png": 622,
	"./nexo.png": 623,
	"./ngc.png": 624,
	"./nio.png": 625,
	"./nkn.png": 626,
	"./nlc2.png": 627,
	"./nlg.png": 628,
	"./nmc.png": 629,
	"./nmr.png": 630,
	"./npxs.png": 631,
	"./ntbc.png": 632,
	"./nuls.png": 633,
	"./nxs.png": 634,
	"./nxt.png": 635,
	"./oax.png": 636,
	"./ok.png": 637,
	"./omg.png": 638,
	"./omni.png": 639,
	"./one.png": 640,
	"./ong.png": 641,
	"./ont.png": 642,
	"./oot.png": 643,
	"./ost.png": 644,
	"./ox.png": 645,
	"./oxt.png": 646,
	"./part.png": 647,
	"./pasc.png": 648,
	"./pasl.png": 649,
	"./pax.png": 650,
	"./paxg.png": 651,
	"./pay.png": 652,
	"./payx.png": 653,
	"./pink.png": 654,
	"./pirl.png": 655,
	"./pivx.png": 656,
	"./plr.png": 657,
	"./poa.png": 658,
	"./poe.png": 659,
	"./polis.png": 660,
	"./poly.png": 661,
	"./pot.png": 662,
	"./powr.png": 663,
	"./ppc.png": 664,
	"./ppp.png": 665,
	"./ppt.png": 666,
	"./pre.png": 667,
	"./prl.png": 668,
	"./pungo.png": 669,
	"./pura.png": 670,
	"./qash.png": 671,
	"./qiwi.png": 672,
	"./qlc.png": 673,
	"./qrl.png": 674,
	"./qsp.png": 675,
	"./qtum.png": 676,
	"./r.png": 677,
	"./rads.png": 678,
	"./rap.png": 679,
	"./rcn.png": 680,
	"./rdd.png": 681,
	"./rdn.png": 682,
	"./ren.png": 683,
	"./rep.png": 684,
	"./repv2.png": 685,
	"./req.png": 686,
	"./rhoc.png": 687,
	"./ric.png": 688,
	"./rise.png": 689,
	"./rlc.png": 690,
	"./rpx.png": 691,
	"./rub.png": 692,
	"./rvn.png": 693,
	"./ryo.png": 694,
	"./safe.png": 695,
	"./safemoon.png": 696,
	"./sai.png": 697,
	"./salt.png": 698,
	"./san.png": 699,
	"./sand.png": 700,
	"./sbd.png": 701,
	"./sberbank.png": 702,
	"./sc.png": 703,
	"./shift.png": 704,
	"./sib.png": 705,
	"./sin.png": 706,
	"./skl.png": 707,
	"./sky.png": 708,
	"./slr.png": 709,
	"./sls.png": 710,
	"./smart.png": 711,
	"./sngls.png": 712,
	"./snm.png": 713,
	"./snt.png": 714,
	"./snx.png": 715,
	"./soc.png": 716,
	"./sol.png": 717,
	"./spacehbit.png": 718,
	"./spank.png": 719,
	"./sphtx.png": 720,
	"./srn.png": 721,
	"./stak.png": 722,
	"./start.png": 723,
	"./steem.png": 724,
	"./storj.png": 725,
	"./storm.png": 726,
	"./stox.png": 727,
	"./stq.png": 728,
	"./strat.png": 729,
	"./stx.png": 730,
	"./sub.png": 731,
	"./sumo.png": 732,
	"./sushi.png": 733,
	"./sys.png": 734,
	"./taas.png": 735,
	"./tau.png": 736,
	"./tbx.png": 737,
	"./tel.png": 738,
	"./ten.png": 739,
	"./tern.png": 740,
	"./tgch.png": 741,
	"./theta.png": 742,
	"./tix.png": 743,
	"./tkn.png": 744,
	"./tks.png": 745,
	"./tnb.png": 746,
	"./tnc.png": 747,
	"./tnt.png": 748,
	"./tomo.png": 749,
	"./tpay.png": 750,
	"./trig.png": 751,
	"./trtl.png": 752,
	"./trx.png": 753,
	"./tusd.png": 754,
	"./tzc.png": 755,
	"./ubq.png": 756,
	"./uma.png": 757,
	"./uni.png": 758,
	"./unity.png": 759,
	"./usd.png": 760,
	"./usdc.png": 761,
	"./usdt.png": 762,
	"./utk.png": 763,
	"./veri.png": 764,
	"./vet.png": 765,
	"./via.png": 766,
	"./vib.png": 767,
	"./vibe.png": 768,
	"./vivo.png": 769,
	"./vlx.png": 770,
	"./vrc.png": 771,
	"./vrsc.png": 772,
	"./vtc.png": 773,
	"./vtho.png": 774,
	"./wabi.png": 775,
	"./wan.png": 776,
	"./waves.png": 777,
	"./wax.png": 778,
	"./wbtc.png": 779,
	"./wgr.png": 780,
	"./wicc.png": 781,
	"./wings.png": 782,
	"./wpr.png": 783,
	"./wtc.png": 784,
	"./x.png": 785,
	"./xas.png": 786,
	"./xbc.png": 787,
	"./xbp.png": 788,
	"./xbt.png": 789,
	"./xby.png": 790,
	"./xcp.png": 791,
	"./xdn.png": 792,
	"./xem.png": 793,
	"./xin.png": 794,
	"./xlm.png": 795,
	"./xmcc.png": 796,
	"./xmg.png": 797,
	"./xmo.png": 798,
	"./xmr.png": 799,
	"./xmy.png": 800,
	"./xp.png": 801,
	"./xpa.png": 802,
	"./xpm.png": 803,
	"./xpr.png": 804,
	"./xrp.png": 805,
	"./xsg.png": 806,
	"./xtz.png": 807,
	"./xuc.png": 808,
	"./xvc.png": 809,
	"./xvg.png": 810,
	"./xzc.png": 811,
	"./yfi.png": 812,
	"./yoyow.png": 813,
	"./zcl.png": 814,
	"./zec.png": 815,
	"./zel.png": 816,
	"./zen.png": 817,
	"./zest.png": 818,
	"./zil.png": 819,
	"./zilla.png": 820,
	"./zrx.png": 821
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1061;
module.exports = webpackAsyncContext;